export const i18nKeyPrefix = 'MAIN-COMMON'
